"use client";

import { createContext, type ReactNode, useContext } from "react";

export interface MapRenderOptions {
  mode?: "live" | "export";
  /** Host configuration only; never serialize into an asset recipe. */
  mapboxAccessToken?: string;
}
const MapRenderContext = createContext<MapRenderOptions>({});

export function MapRenderProvider({ children, ...options }: MapRenderOptions & { children: ReactNode }) {
  const parent = useContext(MapRenderContext);
  return <MapRenderContext.Provider value={{ ...parent, ...options }}>{children}</MapRenderContext.Provider>;
}
export const useMapRenderOptions = () => useContext(MapRenderContext);
